(function () {
  const SECTION_CLASS = "store-locations-section";
  const MODAL_SELECTOR = "modal-dialog[data-store-locations-section]";

  function modalsOf(sectionId) {
    return Array.from(document.querySelectorAll(MODAL_SELECTOR)).filter(
      (modal) => modal.dataset.storeLocationsSection === sectionId
    );
  }

  // Each modal hoists itself onto <body> on connect, so a re-render leaves the
  // previous copy behind under the same id. The newest node is last in document
  // order, so everything before it is stale.
  function pruneStaleModals(sectionId) {
    const latest = new Map();
    modalsOf(sectionId).forEach((modal) => {
      const previous = latest.get(modal.id);
      if (previous) previous.remove();
      latest.set(modal.id, modal);
    });
  }

  class StoreLocations {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.swipers = [];
      this.eventController = new AbortController();

      modalsOf(this.sectionId).forEach((modal) => this.initModal(modal));

      if (this.swipers.length === 0) return;

      root
        .querySelectorAll(".store-locations-card__opener")
        .forEach((opener) => {
          opener.addEventListener(
            "click",
            () => {
              // The panel only gets its final width once it slides in, so the
              // track is re-measured on the frame after the modal opens.
              window.requestAnimationFrame(() => {
                this.swipers.forEach((swiper) => {
                  if (swiper && !swiper.destroyed) swiper.update();
                });
              });
            },
            { signal: this.eventController.signal }
          );
        });
    }

    initModal(modal) {
      if (typeof Swiper === "undefined") return;

      const sliderEl = modal.querySelector(".store-locations-modal__slider");
      if (!sliderEl) return;
      if (sliderEl.querySelectorAll(".swiper-slide").length < 2) return;
      if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);

      this.swipers.push(
        new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 400,
          watchSlideProgress: true,
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            prevEl: modal.querySelector(".slider-nav-button--prev"),
            nextEl: modal.querySelector(".slider-nav-button--next"),
            disabledClass: "swiper-button-disabled",
          },
        })
      );
    }

    destroy() {
      this.eventController.abort();
      this.swipers.forEach((swiper) => {
        if (swiper && !swiper.destroyed) swiper.destroy(true, true);
      });
      this.swipers = [];
    }
  }

  function teardownSection(root) {
    if (!root || !root._storeLocationsInstance) return;
    root._storeLocationsInstance.destroy();
    root._storeLocationsInstance = null;
  }

  function initSection(section) {
    if (!section || !section.classList?.contains(SECTION_CLASS)) return;

    const root = section.querySelector(".store-locations");
    if (!root) return;

    teardownSection(root);
    pruneStaleModals(root.dataset.sectionId);
    root._storeLocationsInstance = new StoreLocations(root);
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeStoreLocationsEvents) {
    window.__themeStoreLocationsEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      if (typeof event.target?.querySelector !== "function") return;

      const root = event.target.querySelector(".store-locations");
      if (!root) return;

      teardownSection(root);
      modalsOf(root.dataset.sectionId).forEach((modal) => modal.remove());
    });
  }
})();
